import { createContext, useContext } from "react";

export type CropInformation =
  | { croppedArea: CropArea; croppedAreaPixels: CropArea }
  | undefined;

export interface CropArea {
  width: number;
  height: number;
  x: number;
  y: number;
}

export interface ImageEditor {
  open: (file: any, instructions: any) => void;
  onconfirm: (output: any) => void;
  oncancel: () => void;
  onclose: () => void;
}

export interface IUploadImageContext {
  zoom: number;
  editor: ImageEditor;
  onSubmit: () => void;
  editImage: string | undefined;
  setZoom: (value: number) => void;
  cropInformation: React.MutableRefObject<CropInformation>;
}

export const UploadImageContext = createContext<IUploadImageContext>({
  zoom: 1,
  editor: {
    open: () => {},
    onconfirm: () => {},
    oncancel: () => {},
    onclose: () => {},
  },
  setZoom: () => {},
  onSubmit: () => {},
  editImage: undefined,
  cropInformation: {
    current: undefined,
  },
});

export const useUploadImageContext = () => useContext(UploadImageContext);
